export default __webpack_public_path__ + "static/media/6.020f1424.jpg";